import './App.css';
import { BrowserRouter as Router, Route, Routes, Link} from 'react-router-dom';
import Home from "./pages/Home";
import CreatePost from "./pages/CreatePost"
import Post from "./pages/Post"
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import {AuthContext} from "./helpers/AuthContext"
import {useState, useEffect} from "react"
import axios from 'axios'
import PageNotFound from './pages/PageNotFound';
function App() {

    const [authState, setAuthState] = useState({
        username: "",
        id: 0,
        status: false
    })
    useEffect(() => {
       axios.get("https://advertisment-app-backend.herokuapp.com/auth/auth",{
           headers:{
            accessToken: localStorage.getItem("accessToken"),
           }
       }).then((response)=>{
           if(response.data.error){
               setAuthState({
                   ...authState, status: false
               })
           }
           else{
               setAuthState({
                username: response.data.username,
                id: response.data.id ,
                status: true
               })
           }
       })
           
        
    }, [])
    const logout =()=>{
        localStorage.removeItem("accessToken")
        setAuthState({
            username: "",
            id: 0,
            status: false
        })
    }

    return ( 
        <div className = "App" >
            <AuthContext.Provider value ={{authState,setAuthState }}>
                <Router >
                    <div className="navbar">
                        <div className ="links">
                            {!authState.status ? (
                                <>
                                    <Link to="/login"> Login</Link>
                                    <Link to="/registration"> Registration</Link>
                                </>
                            ):(
                                <>
                                    <Link to="/CreatePost">Create a Post</Link>
                                    <Link to="/"> Home Page</Link>
                                </>
                            )}
                        </div>
                        <div className="loggedInContainer">
                            <h2>{authState.username} </h2>
                            {authState.status && <Link to ="/login" onClick={logout}> Logout</Link>}
                        </div> 
                    </div>
                    <Routes >
                        <Route path = "/" element = {<Home/>}/>
                        <Route path = "/CreatePost" element = {<CreatePost/>}/>
                        <Route path = "/post/:id" element = {<Post/>}/>
                        <Route path="/registration" element ={<Registration/>} />
                        <Route path="/login" element ={<Login/>} />
                        <Route path="*" element= {<PageNotFound/>}/>
                    </Routes > 
                </Router> 
            </AuthContext.Provider>
        </div>
    );
}

export default App;